import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import SelectState from "./utils/Context/SelectState";
import AppWithRouter from "./routes/AppWithRouter";
import { ReportProvider } from "./utils/Context/ReportContext";
import { NpsStateProvider } from "./utils/Context/NpsState";
import { TenantContext } from "./utils/Context/TenantsContext";
import ChatbotLoader from "./utils/widgets/ChatbotLoader";
import useTenant from "./utils/hooks/useTenant";

function App() {
  const tenant = useTenant();

  useEffect(() => {
    const root = document.documentElement;

    // Apply colors
    Object.entries(tenant.colors).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });

    // Apply favicon
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) favicon.href = tenant.favicon;

    // Apply page/tab title
    document.title = `Client Portal | ${tenant.name}`;
  }, [tenant]);

  return (
    <SelectState>
      <ReportProvider>
        <TenantContext.Provider value={tenant}>
          {tenant.features.chatbot && <ChatbotLoader />}
          <NpsStateProvider>
            <Router>
              <ToastContainer autoClose={3000} position="top-right" />
              <AppWithRouter />
            </Router>
          </NpsStateProvider>
        </TenantContext.Provider>
      </ReportProvider>
    </SelectState>
  );
}

export default App;
